import React, { useState } from "react";
import {
  AudioPlayer,
  Button,
  ChatHistory,
  Modal,
  StatusTags,
  TableAdv,
} from "../../../../../../components";
import { mapTableRows } from "../../../../../../utils";
import rain from "../../../../../../assets/sound/rain.mp3";

const Candidates = () => {
  const [viewCallModal, setViewCallModal] = useState(false);
  const columns = [
    {
      key: "candidateName",
      label: "Candidate Name",
      columnMenu: false,
    },
    {
      key: "role",
      label: "Role",
      columnMenu: false,
    },
    {
      key: "status",
      label: "Status",
      columnMenu: false,
      render: (row) => <StatusTags tag={row.status} />,
    },
    {
      key: "date",
      label: "Date",
      columnMenu: false,
    },
    {
      key: "time",
      label: "Time",
      columnMenu: false,
    },
    {
      key: "duration",
      label: "Duration",
      columnMenu: false,
    },
    {
      key: "action",
      label: "Action",
      columnMenu: false,
      render: (row) => (
        <Button
          type="icon"
          icon={"visibility"}
          variant="text"
          color="black"
          onClick={() => setViewCallModal(true)}
        />
      ),
    },
  ];

  const rows = Array.from({ length: 10 }, (_, i) => ({
    candidateName: "Ershad",
    role: "Frontend Developer",
    date: "05 Mar 2026",
    time: "10:30 AM",
    status: "Answered",
    duration: "10 min",
  }));

  const mappedRows = mapTableRows(rows, columns);
  return (
    <div className="flex flex-col mt-5 overflow-auto">
      <div className="flex flex-grow overflow-auto gap-4 mx-0.5">
        <TableAdv
          showSlNo
          columns={columns}
          rows={mappedRows}
          toolbarRight={{
            search: true,
            filter: true,
            fullScreen: true,
          }}
        />
      </div>
      <Modal
        title={"Candidate Information"}
        isOpen={viewCallModal}
        onClose={() => setViewCallModal(false)}
        width="max-w-5xl"
      >
        <div className="flex flex-col gap-3 ">
          <div className="flex justify-between shadow-lg p-4 rounded">
            <div className="flex flex-col gap-1">
              <h6>Duration of call</h6>
              <p className="text-[12px]">40 min 20 sec</p>
              <p className="text-[12px]">2.00 PM - 2:40 </p>
            </div>
            <AudioPlayer file={rain} download={{ isDownloadable: true }} />
          </div>
          <ChatHistory />
        </div>
      </Modal>
    </div>
  );
};

export default Candidates;
